<template>
  <customModal :containersm="true" @closeModal="closeModal">
    <template #title>
      {{ $t("navigations.update Schedule") }}
    </template>

    <template #body>
      <div class="row">
        <div class="col-md-4 form-group mb-2">
          <label class="mb-0"> Planned Date </label>
          <input
            type="date"
            v-model="formData.plannedDate"
            class="form-control"
            readonly
          />
        </div>
             <div class="col-md-4 form-group mb-2">
          <label class="mb-0"> Immediate Date </label>
          <input
            type="date"
            v-model="formData.immediateDate"
            class="form-control"
          />
        </div>
        <div class="col-md-4 form-group mb-2">
          <label class="mb-0"> Status </label>
          <select v-model="formData.status" class="form-control">
            <option value="">Select Status</option>
            <option value="Planned">Planned</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Rescheduled">Rescheduled</option>
            <option value="Overdue">Overdue</option>
          </select>
        </div>

      </div>

      <div class="text-right mt-2">
        <button class="save_btn py-0 px-4" @click="updateCraSchedule">
          Update
        </button>
      </div>
    </template>
  </customModal>
</template>

<script src="./CraScheduleModal.js"></script>
